module.exports = __webpack_public_path__ + "static/media/RCC.28d5df88.jpeg";